import { Component, OnInit, OnChanges, Input, Output, NgZone, EventEmitter } from '@angular/core';
import { LocationResidentialService } from '../../services/location-residential.service';
import { SharedService } from '../../../shared/services/shared-service.service';
import { Store } from '@ngrx/store';
import { AppState } from 'app/booking/models/app-state.interface';
import { take } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

declare var ga: any;

@Component({
  selector: 'app-location-residential-lookup',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './location-residential-lookup.component.html',
  styleUrls: ['./location-residential-lookup.component.scss'],
  providers: [LocationResidentialService, SharedService]
})
export class LocationResidentialLookupComponent implements OnInit, OnChanges {

  private _lastEnteredValue = '';
  private _timeout;
  private _sendGAPostcodeErrorOnce = false;
  private partialAddress = '';
  private airportCode = '';

  public items: Array<Object> = [];
  public selected: Boolean = false;
  public current: any = 0;
  public locationItem = '';
  public showLoader: Boolean = false;
  public errorPostcodeNotServiced = false;

  @Input()
  placeholder;

  @Input()
  recentAddressLabel;

  @Input()
  manuallyAddressLabel;

  @Input()
  moreAddressLabel;

  @Input()
  errorTextOutOfCoverageArea;

  @Input()
  errorTextPostCodeIsMissing;

  @Input()
  errorTextAddLine;

  @Input()
  userAddresses;

  @Input()
  selectedAddressLine;

  @Input()
  errorNoPostcode;

  @Input()
  errorPostcodeNotEntered;

  @Input()
  isInternational;

  @Output()
  changedAddressLine: EventEmitter<any> = new EventEmitter();

  @Output()
  selectedSavedLocationResidential: EventEmitter<any> = new EventEmitter();

  @Output()
  selectedLocationResidential: EventEmitter<any> = new EventEmitter();

  @Output()
  showManualInput: EventEmitter<any> = new EventEmitter();

  @Output()
  toggleShowMenu: EventEmitter<any> = new EventEmitter();

  constructor(
    private _locationResidentialService: LocationResidentialService,
    private _sharedService: SharedService,
    private _appStore: Store<AppState>,
    private _ngZone: NgZone
  ) { }

  ngOnInit() {
    const state = this.getState(this._appStore);
    const flightData = state.flightReducer.flightDetails.flightResponse;
    const bookingProduct = state.bookingReducer.bookingDetails.bookingProduct;

    const departureCountryCode = flightData.flightStatusDetails[0].departureAirport.airportCode;
    const arrivalCountryCode = flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalAirport.airportCode;
    this.airportCode = bookingProduct === 'abc' ? departureCountryCode : arrivalCountryCode;
    this._locationResidentialService.residentialLocations$
      .subscribe(res => {

        this.showLoader = false;

        this.errorPostcodeNotServiced = false;
        if (res.Items.length === 0) {
          this.errorPostcodeNotServiced = true;

          return;
        }


        // const partialPostcode = this.getPartialPostcode(res.Items[0]);
        // check if (max) first 10 postcodes match
        // const postcodesMatch = (departureCountryCode === 'CH' && bookingProduct === 'abc') || (arrivalCountryCode === 'CH' && bookingProduct === 'ccd') ? res.Items : res.Items.slice(0, 10).every((item) => this.getPartialPostcode(item) === partialPostcode);
        // if (postcodesMatch) {
        this.items = res.Items;
        // ga('send', 'event', 'Locations', 'Postcode search (all)', partialPostcode);

        // postcode is serviced
        if (this.items.length > 0) {
          // ga('send', 'event', 'Locations', 'Postcode search (serviced)', partialPostcode);
        }

        // postcode is not serviced, show error and send GA event
        if (this.items.length === 0) {
          // ga('send', 'event', 'Locations', 'Postcode search (not serviced)', partialPostcode);

          this.errorPostcodeNotServiced = true;

          if (!this._sendGAPostcodeErrorOnce) {
            const currentUrl = location.pathname;
            ga('send', 'event', 'Error', 'Sorry, we can’t find any addresses in our coverage area', currentUrl);

            this._sendGAPostcodeErrorOnce = true;
          }
        }
        // }
      });
  }

  clearInput() {
    this.locationItem = '';
    this.valueChange('');
  }

  valueChange(value) {
    this.changedAddressLine.emit(value);

    // if (cleanValue !== this._lastEnteredValue && value.length >= 4) {
    if (value.length >= 4) {
      this.showLoader = true;
      this._lastEnteredValue = value;
      this.selected = false;
      this.items = [];
      this.partialAddress = value;
      if (this._timeout) { clearTimeout(this._timeout); }

      this._timeout = setTimeout(() => {
        this._locationResidentialService.getLocationData(value, null, this.isInternational);
        this.errorPostcodeNotServiced = false;
        this.showLoader = false;
      }, 500);
    }

  }

  getPartialPostcode(item) {
    // extract postcode from prediction string
    return item.Description.substr(item.Description.lastIndexOf(' ') + 1).match(/\w+/g)[0].toUpperCase();
  }

  setCurrent(index) {
    this.current = index;
  }

  isCurrent(index) {
    return this.current === index;
  }

  selectItem() {
    const selectedItem = this.items[this.current];
    this.handleSelection(selectedItem);
  }

  handleSelection(selectedItem) {
    if (typeof selectedItem !== 'undefined') {
      if (selectedItem.Type === 'Street' || selectedItem.Type === 'Postcode' || selectedItem.Type === 'BuildingNumber' || selectedItem.Type === 'BuildingName') {
        this._locationResidentialService.getLocationData(this.partialAddress, selectedItem.Id, this.isInternational);
        return
      }
      this.selected = true;
      this.showLoader = true;
      this.selectedLocationResidential.emit({ selectedItem, airportCode: this.airportCode });
      this.toggleShowMenu.emit(false);
    }
  }

  handleSavedSelection(selectedItem) {
    this.selected = true;
    this.showLoader = true;
    this.selectedSavedLocationResidential.emit(selectedItem);
    this.toggleShowMenu.emit(false);
    ga('send', 'event', 'Vanilla', 'Location - Selection', 'Selected');
  }

  updateSelection(e) {

    // down key
    if (e.which === 40) {
      this.current = (this.current + 1) % this.items.length;
    } else if (e.which === 38) {
      // up key
      this.current = (this.current ? this.current : this.items.length) - 1;
    } else if (e.which === 13) {
      // enter key
      e.preventDefault();
      this.selectItem();
    }

  }

  close() {
    this.items = [];
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  handleManualInput() {
    this.showManualInput.emit();
    this.toggleShowMenu.emit(false);
    ga('send', 'event', 'Vanilla', 'Location - Selection', 'Manual');
  }

  ngOnChanges(changes: any) {

    this._ngZone.run(() => {
      if (changes.selectedAddressLine &&
        changes.selectedAddressLine.currentValue !== changes.selectedAddressLine.previousValue) {
        this.showLoader = false;
        this.locationItem = '';
        this.locationItem = changes.selectedAddressLine.currentValue[0] || '';
      }
    });
  }

}
